const hierarchyTypeValues = {
    NONE: 0,
    MASTER: 1,
    SLAVE: 2,
    NORMAL: 3
}

export {
    hierarchyTypeValues
}